__turbopack_context__.v({
  "ctaTitle": "CTA-module__jCCtna__ctaTitle",
  "ctaWrapper": "CTA-module__jCCtna__ctaWrapper",
});
